export const pageToTranslationMap = {
  information: 'accountInformation',
  account_settings: 'accountSettings',
};

export const getPageTranslationKey = key => (pageToTranslationMap[key] ? pageToTranslationMap[key] : key);
